import React from 'react';
import styled from 'styled-components';

import Picture from '../../../containers/assets/instructor-onboarding-image25.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 20px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }

  a {
    &:active, &:visited, &:link {
      color: #5c91f5;
      text-decoration: underline;
    }

    &:hover {
      text-decoration: none;
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const NextSteps = () => (
  <Wrapper>
    <Container>
      <Text1>Next Steps</Text1>
      <Text2>
        Hopefully, we covered everything! If there's any questions, please do not hesitate
        to reach out to the Market Games team (<a href="mailto:info@marketgames.io">info@marketgames.io</a>).
      </Text2>

      <Image>
        <img src={Picture} alt="" />
      </Image>

      <Text2>
        <b className="black-note">Here are the next steps:</b><br />
        1. Go to <b>Game Admin</b> to set up the competition, peer review, and grading for your class.<br />
        2. <b>Send us the team list</b> (if you haven't done so already).<br />
        All the best and Welcome to Market Games!
      </Text2>
    </Container>
  </Wrapper>
);

export default NextSteps;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/next-steps.js